import { render } from "./TransportationContractRate.vue?vue&type=template&id=7ff0c0e0&scoped=true"
import script from "./TransportationContractRate.vue?vue&type=script&lang=js"
export * from "./TransportationContractRate.vue?vue&type=script&lang=js"

import "./TransportationContractRate.vue?vue&type=style&index=0&id=7ff0c0e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ff0c0e0"

export default script